// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import {
  getConfiguredDateFormatForKey,
  getConfiguredTimeFormatForKey,
  todayDateObject,
  timeDifferenceInDays
} from './dateTimeUtilities';

export function printInShortDateFormat(
  dateObject,
  dateFormatSetting,
  showWeekday = true,
  showYear = true
) {
  let formatToUse = 'dateFormatShortWithYearWithWeekDay';
  if (!showYear) {
    formatToUse = showWeekday
      ? 'dateFormatShortNoYearWithWeekDay'
      : 'dateFormatShortNoYearNoWeekDay';
  }
  if (!showWeekday && showYear) formatToUse = 'dateFormatShortWithYearNoWeekDay';
  return moment
    .parseZone(dateObject)
    .format(getConfiguredDateFormatForKey(formatToUse, dateFormatSetting));
}

function printAsRelativeDate(dateObject) {
  const diffWithToday = timeDifferenceInDays(dateObject, todayDateObject());
  if (diffWithToday === 0) return i18n('Today');
  if (diffWithToday === 1) return i18n('Tomorrow');
  if (diffWithToday === -1) return i18n('Yesterday');
  return false;
}

export function printInHourDisplayFormat(dateObject, timeFormatSetting) {
  return moment
    .parseZone(dateObject)
    .format(getConfiguredTimeFormatForKey('timeDisplayFormat', timeFormatSetting));
}

export function printInNativeTimeInputFormat(dateObject) {
  return moment.parseZone(dateObject).format('HH:mm');
}

export function printInShortDateAndHourFormat(
  dateObject,
  timeFormatSetting,
  dateFormatSetting,
  showWeekday,
  showYear,
  dateTimeSeparator = ' '
) {
  const timeString = printInHourDisplayFormat(dateObject, timeFormatSetting);
  const dateString = printInShortDateFormat(
    dateObject,
    dateFormatSetting,
    showWeekday,
    showYear
  );
  return `${dateString}${dateTimeSeparator}${timeString}`;
}

export function printInInputDateFormat(dateObject, dateFormatSetting) {
  const standardFormat = getConfiguredDateFormatForKey(
    'dateFormatInput',
    dateFormatSetting
  );
  return moment.parseZone(dateObject).format(standardFormat);
}

export function printInShortFormatOrAsRelativeDate(
  dateObject,
  dateFormatSetting,
  showWeekday,
  showYear
) {
  return (
    printAsRelativeDate(dateObject) ||
    printInShortDateFormat(dateObject, dateFormatSetting, showWeekday, showYear)
  );
}

export function printDurationAsHoursAndMinutes(duration) {
  function pad(numberString) {
    let padded = numberString;
    while (padded.length < 2) {
      padded = `0${padded}`;
    }
    return padded;
  }
  const asMinutes = duration.asMinutes();
  const sign = asMinutes < 0 ? '−' : '+';
  const hours = Math.floor(Math.abs(asMinutes) / 60);
  const minutesWithoutHours = Math.abs(asMinutes) % 60;
  const hourString = hours;
  const minuteString = pad(minutesWithoutHours.toString());
  return `${sign}${hourString}:${minuteString}`;
}
